export const dataLibY = [{
  word: 'yanm',
  partOfSpeech: 'N',
  definition: ['yam'],
  egSentenceKw: null,
  egSentenceEn: null,
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. igname]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'yo',
  partOfSpeech: 'PRO',
  definition: ['they', 'them', 'their'],
  egSentenceKw: 'Yo ban nou gwo chat yo.',
  egSentenceEn: 'They gave us their big cat.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. eux]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'yonn',
  partOfSpeech: 'ADJ',
  definition: ['alone', 'only', 'by oneself'],
  egSentenceKw: 'Mwen yonn ki ka twavay.',
  egSentenceEn: 'I am the only one working.',
  synonym: ['sèlman', 'tousèl'],
  antonym: [null],
  etymology: '[< Fr. seul]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'yis',
  partOfSpeech: 'N',
  definition: ['yeast', 'leavening'],
  egSentenceKw: 'Pen sala fèt san yis.',
  egSentenceEn: 'That bread was made without yeast.',
  synonym: ['lèlven'],
  antonym: [null],
  etymology: '[< Eng. yeast]',
  dialect: '🇱🇨',
  variant: ['is'],
}, {
  word: 'yè',
  partOfSpeech: 'ADV',
  definition: ['yesterday'],
  egSentenceKw: 'Yè mwen manjé douz tig.',
  egSentenceEn: 'Yesterday I ate twelve tigers.',
  synonym: [null],
  antonym: ['denmen'],
  etymology: '[< Fr. hier]',
  dialect: '🇱🇨',
  variant: [null],
},
];
